<template>
    <div v-if="isLoaded" class="error-msg-wrap">
        <div class="form-wrapper slide-up select-employees">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>{{ title || 'Employees' }}</h3>
            <input id="select-employees-search" type="text" v-model="searchQ" placeholder="Search" />
            <div class="select-employees-count">{{ selectedCount }} selected</div>
            <div class="select-employees-list">
                <div v-if="!filtered.length" class="select-employees-empty">No employees match.</div>
                <label v-for="emp in filtered" :key="emp.ID" :class="['checkbox-input', 'select-employees-row', { locked: emp.locked }]">
                    <input type="checkbox" v-model="emp.selected" :disabled="emp.locked" />
                    <span>{{ emp.Name }}<span v-if="emp.SeatTitle" class="select-employees-sub"> · {{ emp.SeatTitle }}</span><span v-if="emp.locked" class="select-employees-sub"> · {{ lockedNote || 'Can\'t be removed' }}</span></span>
                </label>
            </div>
            <input type="submit" value="Save" @click.prevent="save()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

// Picks Team Hub employees (e.g. who a board is shared with). Emits save with the selected employee IDs.
export default defineComponent({
    name: 'SelectEmployees',
    // source: API path returning [{ ID, Name, SeatTitle }] (SeatTitle: from their role sheet seat), normally /api/employees/picker; selectedIds: employee IDs to start checked;
    // lockedIds: ones that stay checked (can't be unchecked), labeled with lockedNote
    props: [ 'source', 'selectedIds', 'title', 'lockedIds', 'lockedNote' ],
    emits: [ 'save', 'close' ],
    data() {
        return {
            employees: [] as any,
            searchQ: '',
            isLoaded: false
        }
    },
    computed: {
        // Checked people first, then everyone else, each alphabetical (as the API sends them)
        filtered(): any[] {
            const q = this.searchQ.trim().toLowerCase();
            const matches = this.employees.filter((emp: any) => !q || (emp.Name || '').toLowerCase().includes(q) || (emp.SeatTitle || '').toLowerCase().includes(q));
            return [ ...matches.filter((emp: any) => emp.initiallySelected), ...matches.filter((emp: any) => !emp.initiallySelected) ];
        },
        selectedCount(): number {
            return this.employees.filter((emp: any) => emp.selected).length;
        }
    },
    async created() {
        const locked = (this.lockedIds || []).map(Number);
        const selected = [ ...(this.selectedIds || []).map(Number), ...locked ];
        await axios.get(`${this.$store.state.apiUrl}${this.source}`)
            .then(resp => {
                this.employees = resp.data.map((emp: any) => {
                    const isSelected = selected.includes(Number(emp.ID));
                    return { ...emp, selected: isSelected, initiallySelected: isSelected, locked: locked.includes(Number(emp.ID)) };
                });
            })
            .catch(e => {
                console.log(e);
                alert('There was an error loading employees');
            })
        this.isLoaded = true;
    },
    methods: {
        save() {
            this.$emit('save', this.employees.filter((emp: any) => emp.selected).map((emp: any) => Number(emp.ID)));
        }
    }
});
</script>

<style scoped>
.select-employees-count { font-size: 12px; color: #a6a29d; margin: -10px 0 10px; }
/* The popup is capped by .error-msg-wrap .form-wrapper (calc(100vh - 120px)); as a flex column, the list
   takes whatever height is left after the title, search and Save, so only the list scrolls */
.select-employees { display: flex; flex-direction: column; overflow: hidden; }
.select-employees > *:not(.form-close) { flex-shrink: 0; }
.select-employees .select-employees-list { flex: 1 1 auto; min-height: 120px; overflow: auto; margin-bottom: 20px; }
.select-employees-row { margin-bottom: 6px; cursor: pointer; }
.select-employees-row.locked { cursor: default; }
.select-employees-sub { color: #a6a29d; font-size: 13px; }
.select-employees-empty { color: #a6a29d; font-size: 14px; }
</style>
